import {createActions} from 'redux-actions';

export const {
    updateWishlistProducts,
} = createActions({
    UPDATE_WISHLIST_PRODUCTS: wishlist => wishlist,
});